import { createGlobalStyle } from '@nfront/global-styles';

import globalStyles from '../styles/globalStyle';

const GlobalStyleComponent = createGlobalStyle`
  ${globalStyles}
`;
export default GlobalStyleComponent;
